const uqlDefinitions = {
    AllInSequence: {
        description:
            "Checks if all elements of first value are elements of second value (usually list)",
        operands_kinds: [
            [
                {
                    name: "list_of_values",
                    description: "List of values of any type",
                    docs: null,
                    serialised_data_type: "List[Any]",
                    internal_data_type: "List[Any]"
                }
            ],
            [
                {
                    name: "list_of_values",
                    description: "List of values of any type",
                    docs: null,
                    serialised_data_type: "List[Any]",
                    internal_data_type: "List[Any]"
                }
            ]
        ],
        operands_number: 2,
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: {
            type: {
                const: "all in (Sequence)",
                enum: ["all in (Sequence)"],
                title: "Type",
                type: "string"
            }
        },
        required: ["type"],
        title: "AllInSequence",
        human_name: "All In Sequence",
        type: "object"
    },
    AnyInSequence: {
        description:
            "Checks if any element of first value is element of second value (usually list)",
        operands_kinds: [
            [
                {
                    name: "list_of_values",
                    description: "List of values of any type",
                    docs: null,
                    serialised_data_type: "List[Any]",
                    internal_data_type: "List[Any]"
                }
            ],
            [
                {
                    name: "list_of_values",
                    description: "List of values of any type",
                    docs: null,
                    serialised_data_type: "List[Any]",
                    internal_data_type: "List[Any]"
                }
            ]
        ],
        operands_number: 2,
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: {
            type: {
                const: "any in (Sequence)",
                enum: ["any in (Sequence)"],
                title: "Type",
                type: "string"
            }
        },
        required: ["type"],
        title: "AnyInSequence",
        human_name: "Any In Sequence",
        type: "object"
    },
    BinaryStatement: {
        properties: {
            type: {
                const: "BinaryStatement",
                enum: ["BinaryStatement"],
                title: "Type",
                type: "string"
            },
            left_operand: {
                discriminator: {
                    mapping: {
                        DynamicOperand: "#/$defs/DynamicOperand",
                        StaticOperand: "#/$defs/StaticOperand"
                    },
                    propertyName: "type"
                },
                oneOf: [{ $ref: "#/$defs/StaticOperand" }, { $ref: "#/$defs/DynamicOperand" }],
                title: "Left Operand"
            },
            comparator: {
                discriminator: {
                    mapping: {
                        "!=": "#/$defs/NotEquals",
                        "(Detection) in zone": "#/$defs/DetectionInZone",
                        "(Number) !=": "#/$defs/NotEquals",
                        "(Number) <": "#/$defs/NumberLower",
                        "(Number) <=": "#/$defs/NumberLowerEqual",
                        "(Number) ==": "#/$defs/Equals",
                        "(Number) >": "#/$defs/NumberGreater",
                        "(Number) >=": "#/$defs/NumberGreaterEqual",
                        "(String) contains": "#/$defs/StringContains",
                        "(String) endsWith": "#/$defs/StringEndsWith",
                        "(String) startsWith": "#/$defs/StringStartsWith",
                        "==": "#/$defs/Equals",
                        "all in (Sequence)": "#/$defs/AllInSequence",
                        "any in (Sequence)": "#/$defs/AnyInSequence",
                        "in (Sequence)": "#/$defs/In"
                    },
                    propertyName: "type"
                },
                oneOf: [
                    { $ref: "#/$defs/In" },
                    { $ref: "#/$defs/AllInSequence" },
                    { $ref: "#/$defs/AnyInSequence" },
                    { $ref: "#/$defs/StringContains" },
                    { $ref: "#/$defs/StringEndsWith" },
                    { $ref: "#/$defs/StringStartsWith" },
                    { $ref: "#/$defs/NumberLowerEqual" },
                    { $ref: "#/$defs/NumberLower" },
                    { $ref: "#/$defs/NumberGreaterEqual" },
                    { $ref: "#/$defs/NumberGreater" },
                    { $ref: "#/$defs/NotEquals" },
                    { $ref: "#/$defs/Equals" },
                    { $ref: "#/$defs/DetectionInZone" }
                ],
                title: "Comparator"
            },
            right_operand: {
                discriminator: {
                    mapping: {
                        DynamicOperand: "#/$defs/DynamicOperand",
                        StaticOperand: "#/$defs/StaticOperand"
                    },
                    propertyName: "type"
                },
                oneOf: [{ $ref: "#/$defs/StaticOperand" }, { $ref: "#/$defs/DynamicOperand" }],
                title: "Right Operand"
            },
            negate: { default: false, title: "Negate", type: "boolean" }
        },
        required: ["type", "left_operand", "comparator", "right_operand"],
        title: "BinaryStatement",
        human_name: "Binary Statement",
        type: "object"
    },
    CaseDefinition: {
        properties: {
            type: {
                const: "CaseDefinition",
                enum: ["CaseDefinition"],
                title: "Type",
                type: "string"
            },
            condition: { $ref: "#/$defs/StatementGroup" },
            result: {
                discriminator: {
                    mapping: {
                        DynamicCaseResult: "#/$defs/DynamicCaseResult",
                        StaticCaseResult: "#/$defs/StaticCaseResult"
                    },
                    propertyName: "type"
                },
                oneOf: [
                    { $ref: "#/$defs/StaticCaseResult" },
                    { $ref: "#/$defs/DynamicCaseResult" }
                ],
                title: "Result"
            }
        },
        required: ["type", "condition", "result"],
        title: "CaseDefinition",
        human_name: "Case Definition",
        type: "object"
    },
    CasesDefinition: {
        properties: {
            type: {
                const: "CasesDefinition",
                enum: ["CasesDefinition"],
                title: "Type",
                type: "string"
            },
            cases: { items: { $ref: "#/$defs/CaseDefinition" }, title: "Cases", type: "array" },
            default: {
                oneOf: [
                    { $ref: "#/$defs/StaticCaseResult" },
                    { $ref: "#/$defs/DynamicCaseResult" }
                ],
                discriminator: {
                    mapping: {
                        DynamicCaseResult: "#/$defs/DynamicCaseResult",
                        StaticCaseResult: "#/$defs/StaticCaseResult"
                    },
                    propertyName: "type"
                },
                title: "Default"
            }
        },
        required: ["type", "cases", "default"],
        title: "CasesDefinition",
        type: "object"
    },
    ClassificationProperty: {
        enum: ["top_class", "top_class_confidence", "all_classes", "all_confidences"],
        title: "ClassificationProperty",
        display_name: "Classification Property",
        display_description:
            "Extract the top class, top confidence, etc. from the classification results.",
        rank: 1,
        type: "string"
    },
    ClassificationPropertyExtract: {
        compound: false,
        description:
            "Extracts property from detections-based prediction(as a list of elements - one element represents single detection)",
        input_kind: [
            {
                name: "classification_prediction",
                description: "Predictions from classifier",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "dict"
            }
        ],
        output_kind: [
            {
                name: "string",
                description: "String value",
                docs: null,
                serialised_data_type: "str",
                internal_data_type: "str"
            },
            {
                name: "list_of_values",
                description: "List of values of any type",
                docs: null,
                serialised_data_type: "List[Any]",
                internal_data_type: "List[Any]"
            },
            {
                name: "float_zero_to_one",
                description: "`float` value in range `[0.0, 1.0]`",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            }
        ],
        properties: {
            type: {
                const: "ClassificationPropertyExtract",
                enum: ["ClassificationPropertyExtract"],
                title: "Type",
                type: "string"
            },
            property_name: { $ref: "#/$defs/ClassificationProperty" }
        },
        required: ["type", "property_name"],
        title: "ClassificationPropertyExtract",

        display_name: "Classification Property",
        display_description:
            "Extract the top class, top confidence, etc. from the classification results.",
        rank: 1,
        type: "object"
    },
    ConvertDictionaryToJSON: {
        description: "Converts dictionary to serialized JSON",
        input_kind: [
            {
                name: "dictionary",
                description: "Dictionary",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "dict"
            }
        ],
        output_kind: [
            {
                name: "string",
                description: "String value",
                docs: null,
                serialised_data_type: "str",
                internal_data_type: "str"
            }
        ],
        properties: {
            type: {
                const: "ConvertDictionaryToJSON",
                enum: ["ConvertDictionaryToJSON"],
                title: "Type",
                type: "string"
            }
        },
        required: ["type"],
        title: "ConvertDictionaryToJSON",
        display_name: "Convert Dictionary to JSON",
        display_description: "Convert the dictionary object to serialized JSON.",
        rank: 13,
        type: "object"
    },
    ConvertImageToBase64: {
        description: "Converts image to base64-encoded JPEG",
        input_kind: [
            {
                name: "image",
                description: "Image in workflows",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "WorkflowImageData"
            }
        ],
        output_kind: [
            {
                name: "string",
                description: "String value",
                docs: null,
                serialised_data_type: "str",
                internal_data_type: "str"
            }
        ],
        properties: {
            type: {
                const: "ConvertImageToBase64",
                enum: ["ConvertImageToBase64"],
                title: "Type",
                type: "string"
            }
        },
        required: ["type"],
        title: "ConvertImageToBase64",
        display_name: "Image to Base64",
        display_description: "Convert an image to a base64-encoded string.",
        rank: 2,
        type: "object"
    },
    ConvertImageToJPEG: {
        description: "Converts image to JPEG",
        input_kind: [
            {
                name: "image",
                description: "Image in workflows",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "WorkflowImageData"
            }
        ],
        output_kind: [
            {
                name: "bytes",
                description: "This kind represent bytes",
                docs: null,
                serialised_data_type: "str",
                internal_data_type: "bytes"
            }
        ],
        properties: {
            type: {
                const: "ConvertImageToJPEG",
                enum: ["ConvertImageToJPEG"],
                title: "Type",
                type: "string"
            },
            compression_level: {
                default: 95,
                maximum: 100,
                minimum: 1,
                title: "Compression Level",
                type: "integer"
            }
        },
        required: ["type"],
        title: "ConvertImageToJPEG",
        display_name: "Image to JPEG",
        display_description: "Convert an image to JPEG format.",
        rank: 2,
        type: "object"
    },
    DetectionInZone: {
        description: "Checks if detection is in zone",
        operands_kinds: [
            [
                {
                    name: "detection",
                    description:
                        "Single element of detections-based prediction (like `object_detection_prediction`)",
                    docs: null,
                    serialised_data_type:
                        "Tuple[list, Optional[list], Optional[float], Optional[float], Optional[int], dict]",
                    internal_data_type:
                        "Tuple[np.ndarray, Optional[np.ndarray], Optional[float], Optional[float], Optional[int], dict]"
                },
                {
                    name: "zone",
                    description: "Definition of polygon zone",
                    docs: null,
                    serialised_data_type: "List[Tuple[int, int]]",
                    internal_data_type: "List[Tuple[int, int]]"
                }
            ]
        ],
        operands_number: 2,
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: {
            type: {
                const: "(Detection) in zone",
                enum: ["(Detection) in zone"],
                title: "Type",
                type: "string"
            }
        },
        required: ["type"],
        title: "DetectionInZone",
        type: "object"
    },
    DetectionsFilter: {
        compound: true,
        description:
            "Filters out unwanted elements from detections-based prediction by applying filter operation in context of every single detection within prediction",
        input_kind: [
            {
                name: "object_detection_prediction",
                description:
                    "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "instance_segmentation_prediction",
                description:
                    "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "keypoint_detection_prediction",
                description:
                    "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            }
        ],
        nested_operation_input_kind: [
            {
                name: "detection",
                description:
                    "Single element of detections-based prediction (like `object_detection_prediction`)",
                docs: null,
                serialised_data_type:
                    "Tuple[list, Optional[list], Optional[float], Optional[float], Optional[int], dict]",
                internal_data_type:
                    "Tuple[np.ndarray, Optional[np.ndarray], Optional[float], Optional[float], Optional[int], dict]"
            }
        ],
        nested_operation_output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        output_kind: [
            {
                name: "object_detection_prediction",
                description:
                    "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "instance_segmentation_prediction",
                description:
                    "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "keypoint_detection_prediction",
                description:
                    "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            }
        ],
        properties: {
            type: {
                const: "DetectionsFilter",
                enum: ["DetectionsFilter"],
                title: "Type",
                type: "string"
            },
            filter_operation: { $ref: "#/$defs/StatementGroup" }
        },
        required: ["type", "filter_operation"],
        title: "DetectionsFilter",
        type: "object"
    },
    DetectionsOffset: {
        compound: false,
        description: "Makes detected bounding boxes bigger by applying offset to its size",
        input_kind: [
            {
                name: "object_detection_prediction",
                description:
                    "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "instance_segmentation_prediction",
                description:
                    "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "keypoint_detection_prediction",
                description:
                    "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            }
        ],
        output_kind: [
            {
                name: "object_detection_prediction",
                description:
                    "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "instance_segmentation_prediction",
                description:
                    "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "keypoint_detection_prediction",
                description:
                    "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            }
        ],
        properties: {
            type: {
                const: "DetectionsOffset",
                enum: ["DetectionsOffset"],
                title: "Type",
                type: "string"
            },
            offset_x: { title: "Offset X", type: "integer" },
            offset_y: { title: "Offset Y", type: "integer" }
        },
        required: ["type", "offset_x", "offset_y"],
        title: "DetectionsOffset",
        display_name: "Offset Detections",
        display_description:
            "Increase the size of detected bounding boxes by offsetting the width and height.",
        rank: 7,
        type: "object"
    },
    DetectionsProperty: {
        enum: [
            "confidence",
            "class_name",
            "x_min",
            "x_max",
            "y_min",
            "y_max",
            "size",
            "class_id",
            "center",
            "top_left",
            "top_right",
            "bottom_left",
            "bottom_right",
            "in_out",
            "path_deviation",
            "polygon",
            "time_in_zone",
            "tracker_id",
            "velocity",
            "speed",
            "smoothed_velocity",
            "smoothed_speed",
            "image_dimensions",
            "prediction_type",
            "keypoints_xy",
            "rect",
            "width",
            "height",
            "angle"
        ],
        title: "DetectionsProperty",
        type: "string"
    },
    DetectionsPropertyExtract: {
        compound: false,
        description:
            "Extracts property from detections-based prediction(as a list of elements - one element represents single detection)",
        input_kind: [
            {
                name: "object_detection_prediction",
                description:
                    "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "instance_segmentation_prediction",
                description:
                    "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "keypoint_detection_prediction",
                description:
                    "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            }
        ],
        output_kind: [
            {
                name: "list_of_values",
                description: "List of values of any type",
                docs: null,
                serialised_data_type: "List[Any]",
                internal_data_type: "List[Any]"
            }
        ],
        properties: {
            type: {
                const: "DetectionsPropertyExtract",
                enum: ["DetectionsPropertyExtract"],
                title: "Type",
                type: "string"
            },
            property_name: { $ref: "#/$defs/DetectionsProperty" }
        },
        required: ["type", "property_name"],
        title: "DetectionsPropertyExtract",
        display_name: "Extract Property",
        display_description:
            "Extract a list of values from the predictions, such as class names or confidences.",
        rank: 1,
        type: "object"
    },
    DetectionsRename: {
        compound: false,
        description: "Renames classes in detections based on provided mapping",
        input_kind: [
            {
                name: "object_detection_prediction",
                description:
                    "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "instance_segmentation_prediction",
                description:
                    "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "keypoint_detection_prediction",
                description:
                    "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            }
        ],
        output_kind: [
            {
                name: "object_detection_prediction",
                description:
                    "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "instance_segmentation_prediction",
                description:
                    "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "keypoint_detection_prediction",
                description:
                    "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            }
        ],
        properties: {
            type: {
                const: "DetectionsRename",
                enum: ["DetectionsRename"],
                title: "Type",
                type: "string"
            },
            class_map: {
                anyOf: [
                    { additionalProperties: { type: "string" }, type: "object" },
                    { type: "string" }
                ],
                description:
                    "Dictionary with classes replacement mapping or name of parameter delivering the mapping",
                title: "Class Map"
            },
            strict: {
                anyOf: [{ type: "boolean" }, { type: "string" }],
                default: true,
                description:
                    "Flag to decide if all class must be declared in `class_map` or name of parameter delivering the mapping. When set `True` all detections classes must be declared, otherwise error is raised.",
                title: "Strict"
            },
            new_classes_id_offset: {
                default: 1024,
                description:
                    "When `strict` is `False`, this value determines the first index given to re-mapped classes. This value let user create new class ids whichwill not overlap with original identifiers.",
                title: "New Classes Id Offset",
                type: "integer"
            }
        },
        required: ["type", "class_map"],
        title: "DetectionsRename",
        type: "object"
    },
    DetectionsSelection: {
        compound: false,
        description: "Selects bounding boxes based on predefined criterias",
        input_kind: [
            {
                name: "object_detection_prediction",
                description:
                    "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "instance_segmentation_prediction",
                description:
                    "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "keypoint_detection_prediction",
                description:
                    "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            }
        ],
        output_kind: [
            {
                name: "object_detection_prediction",
                description:
                    "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "instance_segmentation_prediction",
                description:
                    "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "keypoint_detection_prediction",
                description:
                    "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            }
        ],
        properties: {
            type: {
                const: "DetectionsSelection",
                enum: ["DetectionsSelection"],
                title: "Type",
                type: "string"
            },
            mode: { $ref: "#/$defs/DetectionsSelectionMode" }
        },
        required: ["type", "mode"],
        title: "DetectionsSelection",
        display_name: "Select Detection",
        display_description:
            "Select a single prediction from the list based on the specified criteria.",
        rank: 6,
        type: "object"
    },
    DetectionsSelectionMode: {
        enum: ["left_most", "right_most", "top_confidence"],
        title: "DetectionsSelectionMode",
        type: "string"
    },
    DetectionsShift: {
        compound: false,
        description: "Shifting detected bounding boxes in assigned direction",
        input_kind: [
            {
                name: "object_detection_prediction",
                description:
                    "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "instance_segmentation_prediction",
                description:
                    "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "keypoint_detection_prediction",
                description:
                    "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            }
        ],
        output_kind: [
            {
                name: "object_detection_prediction",
                description:
                    "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "instance_segmentation_prediction",
                description:
                    "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "keypoint_detection_prediction",
                description:
                    "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            }
        ],
        properties: {
            type: {
                const: "DetectionsShift",
                enum: ["DetectionsShift"],
                title: "Type",
                type: "string"
            },
            shift_x: { title: "Shift X", type: "integer" },
            shift_y: { title: "Shift Y", type: "integer" }
        },
        required: ["type", "shift_x", "shift_y"],
        title: "DetectionsShift",
        display_name: "Shift Detections",
        display_description: "Move the detected bounding boxes in a specified direction.",
        rank: 10,
        type: "object"
    },
    DetectionsSortProperties: {
        enum: ["confidence", "x_min", "x_max", "y_min", "y_max", "size", "center_x", "center_y"],
        title: "DetectionsSortProperties",
        type: "string"
    },
    DetectionsToDictionary: {
        compound: false,
        description: "Converts detections into `inference` response format dictionary",
        input_kind: [
            {
                name: "object_detection_prediction",
                description:
                    "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "instance_segmentation_prediction",
                description:
                    "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "keypoint_detection_prediction",
                description:
                    "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            }
        ],
        output_kind: [
            {
                name: "dictionary",
                description: "Dictionary",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "dict"
            }
        ],
        properties: {
            type: {
                const: "DetectionsToDictionary",
                enum: ["DetectionsToDictionary"],
                title: "Type",
                type: "string"
            }
        },
        required: ["type"],
        title: "DetectionsToDictionary",
        display_name: "Convert to Dictionary",
        display_description: "Convert the detections to a dictionary object.",
        rank: 20,
        type: "object"
    },
    TimestampToISOFormat: {
        compound: false,
        description: "Serializes timestamp to ISO format.",
        input_kind: [
            {
                name: "timestamp",
                description: "Timestamp object",
                docs: null,
                serialised_data_type: "str",
                internal_data_type: "datetime"
            }
        ],
        output_kind: [
            {
                name: "string",
                description: "String value",
                docs: null,
                serialised_data_type: "str",
                internal_data_type: "str"
            }
        ],
        properties: {
            type: {
                const: "TimestampToISOFormat",
                enum: ["TimestampToISOFormat"],
                title: "Type",
                type: "string"
            }
        },
        required: ["type"],
        title: "TimestampToISOFormat",
        display_name: "Timestamp to ISO format",
        display_description: "Serializes timestamp to ISO format.",
        rank: 20,
        type: "object"
    },
    PickDetectionsByParentClass: {
        compound: false,
        description:
            "Picks only those detections which are located inside parent detections of specific class",
        input_kind: [
            {
                name: "object_detection_prediction",
                description:
                    "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "instance_segmentation_prediction",
                description:
                    "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "keypoint_detection_prediction",
                description:
                    "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            }
        ],
        output_kind: [
            {
                name: "object_detection_prediction",
                description:
                    "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "instance_segmentation_prediction",
                description:
                    "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "keypoint_detection_prediction",
                description:
                    "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            }
        ],
        properties: {
            type: {
                const: "PickDetectionsByParentClass",
                enum: ["PickDetectionsByParentClass"],
                title: "Type",
                type: "string"
            },
            parent_class: { title: "Parent Class", type: "string" }
        },
        required: ["type"],
        title: "PickDetectionsByParentClass",
        display_name: "Pick Detections By Parent Class",
        display_description: "Select only detections within bounding box of parent class.",
        rank: 20,
        type: "object"
    },
    Divide: {
        compound: false,
        description: "Dividing value against other",
        input_kind: [
            {
                name: "integer",
                description: "Integer value",
                docs: null,
                serialised_data_type: "int",
                internal_data_type: "int"
            },
            {
                name: "float",
                description: "Float value",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            },
            {
                name: "float_zero_to_one",
                description: "`float` value in range `[0.0, 1.0]`",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            }
        ],
        output_kind: [
            {
                name: "integer",
                description: "Integer value",
                docs: null,
                serialised_data_type: "int",
                internal_data_type: "int"
            },
            {
                name: "float",
                description: "Float value",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            },
            {
                name: "float_zero_to_one",
                description: "`float` value in range `[0.0, 1.0]`",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            }
        ],
        properties: {
            type: { const: "Divide", enum: ["Divide"], title: "Type", type: "string" },
            other: { anyOf: [{ type: "integer" }, { type: "number" }], title: "Other" }
        },
        required: ["type", "other"],
        title: "Divide",
        display_name: "Divide",
        display_description: "Divide the input value by a specified amount.",
        rank: 16,
        type: "object"
    },
    DoesNotExist: {
        description: "Checks if value is not given (`None`)",
        operands_kinds: [
            [
                {
                    name: "*",
                    description: "Equivalent of any element",
                    docs: null,
                    serialised_data_type: "Any",
                    internal_data_type: "Any"
                }
            ]
        ],
        operands_number: 1,
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: {
            type: { const: "DoesNotExist", enum: ["DoesNotExist"], title: "Type", type: "string" }
        },
        required: ["type"],
        title: "DoesNotExist",
        type: "object"
    },
    DynamicCaseResult: {
        properties: {
            type: {
                const: "DynamicCaseResult",
                enum: ["DynamicCaseResult"],
                title: "Type",
                type: "string"
            },
            parameter_name: { title: "Parameter Name", type: "string" },
            operations: {
                anyOf: [
                    {
                        items: {
                            discriminator: {
                                mapping: {
                                    ClassificationPropertyExtract:
                                        "#/$defs/ClassificationPropertyExtract",
                                    ConvertDictionaryToJSON: "#/$defs/ConvertDictionaryToJSON",
                                    ConvertImageToBase64: "#/$defs/ConvertImageToBase64",
                                    ConvertImageToJPEG: "#/$defs/ConvertImageToJPEG",
                                    DetectionsFilter: "#/$defs/DetectionsFilter",
                                    DetectionsOffset: "#/$defs/DetectionsOffset",
                                    DetectionsPropertyExtract: "#/$defs/DetectionsPropertyExtract",
                                    DetectionsRename: "#/$defs/DetectionsRename",
                                    DetectionsSelection: "#/$defs/DetectionsSelection",
                                    DetectionsShift: "#/$defs/DetectionsShift",
                                    DetectionsToDictionary: "#/$defs/DetectionsToDictionary",
                                    Divide: "#/$defs/Divide",
                                    ExtractDetectionProperty: "#/$defs/ExtractDetectionProperty",
                                    ExtractImageProperty: "#/$defs/ExtractImageProperty",
                                    LookupTable: "#/$defs/LookupTable",
                                    Multiply: "#/$defs/Multiply",
                                    NumberRound: "#/$defs/NumberRound",
                                    NumericSequenceAggregate: "#/$defs/NumericSequenceAggregate",
                                    RandomNumber: "#/$defs/RandomNumber",
                                    SequenceAggregate: "#/$defs/SequenceAggregate",
                                    SequenceApply: "#/$defs/SequenceApply",
                                    SequenceLength: "#/$defs/SequenceLength",
                                    SequenceMap: "#/$defs/SequenceMap",
                                    SortDetections: "#/$defs/SortDetections",
                                    StringMatches: "#/$defs/StringMatches",
                                    StringSubSequence: "#/$defs/StringSubSequence",
                                    StringToLowerCase: "#/$defs/StringToLowerCase",
                                    StringToUpperCase: "#/$defs/StringToUpperCase",
                                    ToBoolean: "#/$defs/ToBoolean",
                                    ToNumber: "#/$defs/ToNumber",
                                    ToString: "#/$defs/ToString"
                                },
                                propertyName: "type"
                            },
                            oneOf: [
                                { $ref: "#/$defs/StringToLowerCase" },
                                { $ref: "#/$defs/StringToUpperCase" },
                                { $ref: "#/$defs/LookupTable" },
                                { $ref: "#/$defs/ToNumber" },
                                { $ref: "#/$defs/NumberRound" },
                                { $ref: "#/$defs/SequenceMap" },
                                { $ref: "#/$defs/SequenceApply" },
                                { $ref: "#/$defs/NumericSequenceAggregate" },
                                { $ref: "#/$defs/ToString" },
                                { $ref: "#/$defs/ToBoolean" },
                                { $ref: "#/$defs/StringSubSequence" },
                                { $ref: "#/$defs/DetectionsPropertyExtract" },
                                { $ref: "#/$defs/SequenceAggregate" },
                                { $ref: "#/$defs/ExtractDetectionProperty" },
                                { $ref: "#/$defs/DetectionsFilter" },
                                { $ref: "#/$defs/DetectionsOffset" },
                                { $ref: "#/$defs/DetectionsShift" },
                                { $ref: "#/$defs/DetectionsRename" },
                                { $ref: "#/$defs/RandomNumber" },
                                { $ref: "#/$defs/StringMatches" },
                                { $ref: "#/$defs/ExtractImageProperty" },
                                { $ref: "#/$defs/SequenceLength" },
                                { $ref: "#/$defs/Multiply" },
                                { $ref: "#/$defs/Divide" },
                                { $ref: "#/$defs/DetectionsSelection" },
                                { $ref: "#/$defs/SortDetections" },
                                { $ref: "#/$defs/ClassificationPropertyExtract" },
                                { $ref: "#/$defs/ConvertImageToJPEG" },
                                { $ref: "#/$defs/ConvertImageToBase64" },
                                { $ref: "#/$defs/DetectionsToDictionary" },
                                { $ref: "#/$defs/ConvertDictionaryToJSON" }
                            ]
                        },
                        type: "array"
                    },
                    { type: "null" }
                ],
                default: null,
                title: "Operations"
            }
        },
        required: ["type", "parameter_name"],
        title: "DynamicCaseResult",
        type: "object"
    },
    DynamicOperand: {
        properties: {
            type: {
                const: "DynamicOperand",
                enum: ["DynamicOperand"],
                title: "Type",
                type: "string"
            },
            operations: {
                items: {
                    discriminator: {
                        mapping: {
                            ClassificationPropertyExtract: "#/$defs/ClassificationPropertyExtract",
                            ConvertDictionaryToJSON: "#/$defs/ConvertDictionaryToJSON",
                            ConvertImageToBase64: "#/$defs/ConvertImageToBase64",
                            ConvertImageToJPEG: "#/$defs/ConvertImageToJPEG",
                            DetectionsFilter: "#/$defs/DetectionsFilter",
                            DetectionsOffset: "#/$defs/DetectionsOffset",
                            DetectionsPropertyExtract: "#/$defs/DetectionsPropertyExtract",
                            DetectionsRename: "#/$defs/DetectionsRename",
                            DetectionsSelection: "#/$defs/DetectionsSelection",
                            DetectionsShift: "#/$defs/DetectionsShift",
                            DetectionsToDictionary: "#/$defs/DetectionsToDictionary",
                            Divide: "#/$defs/Divide",
                            ExtractDetectionProperty: "#/$defs/ExtractDetectionProperty",
                            ExtractImageProperty: "#/$defs/ExtractImageProperty",
                            LookupTable: "#/$defs/LookupTable",
                            Multiply: "#/$defs/Multiply",
                            NumberRound: "#/$defs/NumberRound",
                            NumericSequenceAggregate: "#/$defs/NumericSequenceAggregate",
                            RandomNumber: "#/$defs/RandomNumber",
                            SequenceAggregate: "#/$defs/SequenceAggregate",
                            SequenceApply: "#/$defs/SequenceApply",
                            SequenceLength: "#/$defs/SequenceLength",
                            SequenceMap: "#/$defs/SequenceMap",
                            SortDetections: "#/$defs/SortDetections",
                            StringMatches: "#/$defs/StringMatches",
                            StringSubSequence: "#/$defs/StringSubSequence",
                            StringToLowerCase: "#/$defs/StringToLowerCase",
                            StringToUpperCase: "#/$defs/StringToUpperCase",
                            ToBoolean: "#/$defs/ToBoolean",
                            ToNumber: "#/$defs/ToNumber",
                            ToString: "#/$defs/ToString"
                        },
                        propertyName: "type"
                    },
                    oneOf: [
                        { $ref: "#/$defs/StringToLowerCase" },
                        { $ref: "#/$defs/StringToUpperCase" },
                        { $ref: "#/$defs/LookupTable" },
                        { $ref: "#/$defs/ToNumber" },
                        { $ref: "#/$defs/NumberRound" },
                        { $ref: "#/$defs/SequenceMap" },
                        { $ref: "#/$defs/SequenceApply" },
                        { $ref: "#/$defs/NumericSequenceAggregate" },
                        { $ref: "#/$defs/ToString" },
                        { $ref: "#/$defs/ToBoolean" },
                        { $ref: "#/$defs/StringSubSequence" },
                        { $ref: "#/$defs/DetectionsPropertyExtract" },
                        { $ref: "#/$defs/SequenceAggregate" },
                        { $ref: "#/$defs/ExtractDetectionProperty" },
                        { $ref: "#/$defs/DetectionsFilter" },
                        { $ref: "#/$defs/DetectionsOffset" },
                        { $ref: "#/$defs/DetectionsShift" },
                        { $ref: "#/$defs/DetectionsRename" },
                        { $ref: "#/$defs/RandomNumber" },
                        { $ref: "#/$defs/StringMatches" },
                        { $ref: "#/$defs/ExtractImageProperty" },
                        { $ref: "#/$defs/SequenceLength" },
                        { $ref: "#/$defs/Multiply" },
                        { $ref: "#/$defs/Divide" },
                        { $ref: "#/$defs/DetectionsSelection" },
                        { $ref: "#/$defs/SortDetections" },
                        { $ref: "#/$defs/ClassificationPropertyExtract" },
                        { $ref: "#/$defs/ConvertImageToJPEG" },
                        { $ref: "#/$defs/ConvertImageToBase64" },
                        { $ref: "#/$defs/DetectionsToDictionary" },
                        { $ref: "#/$defs/ConvertDictionaryToJSON" }
                    ]
                },
                title: "Operations",
                type: "array"
            },
            operand_name: { default: "_", title: "Operand Name", type: "string" }
        },
        required: ["type"],
        title: "DynamicOperand",
        type: "object"
    },
    Equals: {
        description: "Checks if two values given are equal",
        operands_kinds: [
            [
                {
                    name: "integer",
                    description: "Integer value",
                    docs: null,
                    serialised_data_type: "int",
                    internal_data_type: "int"
                },
                {
                    name: "string",
                    description: "String value",
                    docs: null,
                    serialised_data_type: "str",
                    internal_data_type: "str"
                },
                {
                    name: "float",
                    description: "Float value",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                },
                {
                    name: "float_zero_to_one",
                    description: "`float` value in range `[0.0, 1.0]`",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                },
                {
                    name: "boolean",
                    description: "Boolean flag",
                    docs: null,
                    serialised_data_type: "bool",
                    internal_data_type: "bool"
                },
                {
                    name: "list_of_values",
                    description: "List of values of any type",
                    docs: null,
                    serialised_data_type: "List[Any]",
                    internal_data_type: "List[Any]"
                }
            ],
            [
                {
                    name: "integer",
                    description: "Integer value",
                    docs: null,
                    serialised_data_type: "int",
                    internal_data_type: "int"
                },
                {
                    name: "string",
                    description: "String value",
                    docs: null,
                    serialised_data_type: "str",
                    internal_data_type: "str"
                },
                {
                    name: "float",
                    description: "Float value",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                },
                {
                    name: "float_zero_to_one",
                    description: "`float` value in range `[0.0, 1.0]`",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                },
                {
                    name: "boolean",
                    description: "Boolean flag",
                    docs: null,
                    serialised_data_type: "bool",
                    internal_data_type: "bool"
                },
                {
                    name: "list_of_values",
                    description: "List of values of any type",
                    docs: null,
                    serialised_data_type: "List[Any]",
                    internal_data_type: "List[Any]"
                }
            ]
        ],
        operands_number: 2,
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: { type: { enum: ["(Number) ==", "=="], title: "Type", type: "string" } },
        required: ["type"],
        title: "Equals",
        type: "object"
    },
    Exists: {
        description: "Checks if value is given (not `None`)",
        operands_kinds: [
            [
                {
                    name: "*",
                    description: "Equivalent of any element",
                    docs: null,
                    serialised_data_type: "Any",
                    internal_data_type: "Any"
                }
            ]
        ],
        operands_number: 1,
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: { type: { const: "Exists", enum: ["Exists"], title: "Type", type: "string" } },
        required: ["type"],
        title: "Exists",
        type: "object"
    },
    ExtractDetectionProperty: {
        compound: false,
        description: "Extracts property from single detection",
        input_kind: [
            {
                name: "detection",
                description:
                    "Single element of detections-based prediction (like `object_detection_prediction`)",
                docs: null,
                serialised_data_type:
                    "Tuple[list, Optional[list], Optional[float], Optional[float], Optional[int], dict]",
                internal_data_type:
                    "Tuple[np.ndarray, Optional[np.ndarray], Optional[float], Optional[float], Optional[int], dict]"
            }
        ],
        output_kind: [
            {
                name: "*",
                description: "Equivalent of any element",
                docs: null,
                serialised_data_type: "Any",
                internal_data_type: "Any"
            }
        ],
        properties: {
            type: {
                const: "ExtractDetectionProperty",
                enum: ["ExtractDetectionProperty"],
                title: "Type",
                type: "string"
            },
            property_name: { $ref: "#/$defs/DetectionsProperty" }
        },
        required: ["type", "property_name"],
        title: "ExtractDetectionProperty",
        type: "object"
    },
    ExtractImageProperty: {
        description: "Extracts specific property of image (like size)",
        input_kind: [
            {
                name: "image",
                description: "Image in workflows",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "WorkflowImageData"
            }
        ],
        output_kind: [
            {
                name: "integer",
                description: "Integer value",
                docs: null,
                serialised_data_type: "int",
                internal_data_type: "int"
            }
        ],
        properties: {
            type: {
                const: "ExtractImageProperty",
                enum: ["ExtractImageProperty"],
                title: "Type",
                type: "string"
            },
            property_name: { $ref: "#/$defs/ImageProperty" }
        },
        required: ["type", "property_name"],
        title: "ExtractImageProperty",
        display_name: "Extract Image Property",
        display_description: "Extract a property from an image, such as size, height, or width.",
        rank: 1,
        type: "object"
    },
    ExtractFrameMetadata: {
        description: "Extracts specific property of frame (frame number, timestamp)",
        input_kind: [
            {
                name: "image",
                description: "Image in workflows",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "WorkflowImageData"
            }
        ],
        output_kind: [
            {
                name: "integer",
                description: "Integer value",
                docs: null,
                serialised_data_type: "int",
                internal_data_type: "int"
            },
            {
                name: "float",
                description: "Float value",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            },
            {
                name: "timestamp",
                description: "Timestamp object",
                docs: null,
                serialised_data_type: "str",
                internal_data_type: "datetime"
            }
        ],
        properties: {
            type: {
                const: "ExtractFrameMetadata",
                enum: ["ExtractFrameMetadata"],
                title: "Type",
                type: "string"
            },
            property_name: { $ref: "#/$defs/FrameMetadataProperty" }
        },
        required: ["type", "property_name"],
        title: "ExtractFrameMetadata",
        display_name: "Extract Video Frame Property",
        display_description:
            "Extract a property from video frame such as frame number or timestamp",
        rank: 1,
        type: "object"
    },
    ImageProperty: {
        enum: ["size", "height", "width", "aspect_ratio"],
        title: "ImageProperty",
        type: "string"
    },
    FrameMetadataProperty: {
        enum: ["frame_number", "frame_timestamp", "seconds_since_start"],
        title: "FrameMetadataProperty",
        type: "string"
    },
    In: {
        description:
            "Checks if first value is element of second value (usually list or dictionary)",
        operands_kinds: [
            [
                {
                    name: "string",
                    description: "String value",
                    docs: null,
                    serialised_data_type: "str",
                    internal_data_type: "str"
                },
                {
                    name: "integer",
                    description: "Integer value",
                    docs: null,
                    serialised_data_type: "int",
                    internal_data_type: "int"
                },
                {
                    name: "float",
                    description: "Float value",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                },
                {
                    name: "float_zero_to_one",
                    description: "`float` value in range `[0.0, 1.0]`",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                }
            ],
            [
                {
                    name: "list_of_values",
                    description: "List of values of any type",
                    docs: null,
                    serialised_data_type: "List[Any]",
                    internal_data_type: "List[Any]"
                },
                {
                    name: "dictionary",
                    description: "Dictionary",
                    docs: null,
                    serialised_data_type: "dict",
                    internal_data_type: "dict"
                }
            ]
        ],
        operands_number: 2,
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: {
            type: { const: "in (Sequence)", enum: ["in (Sequence)"], title: "Type", type: "string" }
        },
        required: ["type"],
        title: "In",
        type: "object"
    },
    IsEmpty: {
        description: "Checks if sequence is empty",
        operands_kinds: [
            [
                {
                    name: "list_of_values",
                    description: "List of values of any type",
                    docs: null,
                    serialised_data_type: "List[Any]",
                    internal_data_type: "List[Any]"
                },
                {
                    name: "dictionary",
                    description: "Dictionary",
                    docs: null,
                    serialised_data_type: "dict",
                    internal_data_type: "dict"
                },
                {
                    name: "object_detection_prediction",
                    description:
                        "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                    docs: null,
                    serialised_data_type: "dict",
                    internal_data_type: "sv.Detections"
                },
                {
                    name: "instance_segmentation_prediction",
                    description:
                        "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                    docs: null,
                    serialised_data_type: "dict",
                    internal_data_type: "sv.Detections"
                },
                {
                    name: "keypoint_detection_prediction",
                    description:
                        "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                    docs: null,
                    serialised_data_type: "dict",
                    internal_data_type: "sv.Detections"
                }
            ]
        ],
        operands_number: 1,
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: {
            type: {
                const: "(Sequence) is empty",
                enum: ["(Sequence) is empty"],
                title: "Type",
                type: "string"
            }
        },
        required: ["type"],
        title: "IsEmpty",
        type: "object"
    },
    IsFalse: {
        description: "Checks if value is `False`",
        operands_kinds: [
            [
                {
                    name: "boolean",
                    description: "Boolean flag",
                    docs: null,
                    serialised_data_type: "bool",
                    internal_data_type: "bool"
                }
            ]
        ],
        operands_number: 1,
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: {
            type: {
                const: "(Boolean) is False",
                enum: ["(Boolean) is False"],
                title: "Type",
                type: "string"
            }
        },
        required: ["type"],
        title: "IsFalse",
        type: "object"
    },
    IsNotEmpty: {
        description: "Checks if sequence is not empty",
        operands_kinds: [
            [
                {
                    name: "list_of_values",
                    description: "List of values of any type",
                    docs: null,
                    serialised_data_type: "List[Any]",
                    internal_data_type: "List[Any]"
                },
                {
                    name: "dictionary",
                    description: "Dictionary",
                    docs: null,
                    serialised_data_type: "dict",
                    internal_data_type: "dict"
                },
                {
                    name: "object_detection_prediction",
                    description:
                        "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                    docs: null,
                    serialised_data_type: "dict",
                    internal_data_type: "sv.Detections"
                },
                {
                    name: "instance_segmentation_prediction",
                    description:
                        "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                    docs: null,
                    serialised_data_type: "dict",
                    internal_data_type: "sv.Detections"
                },
                {
                    name: "keypoint_detection_prediction",
                    description:
                        "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                    docs: null,
                    serialised_data_type: "dict",
                    internal_data_type: "sv.Detections"
                }
            ]
        ],
        operands_number: 1,
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: {
            type: {
                const: "(Sequence) is not empty",
                enum: ["(Sequence) is not empty"],
                title: "Type",
                type: "string"
            }
        },
        required: ["type"],
        title: "IsNotEmpty",
        type: "object"
    },
    IsTrue: {
        description: "Checks if value is `True`",
        operands_kinds: [
            [
                {
                    name: "boolean",
                    description: "Boolean flag",
                    docs: null,
                    serialised_data_type: "bool",
                    internal_data_type: "bool"
                }
            ]
        ],
        operands_number: 1,
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: {
            type: {
                const: "(Boolean) is True",
                enum: ["(Boolean) is True"],
                title: "Type",
                type: "string"
            }
        },
        required: ["type"],
        title: "IsTrue",
        type: "object"
    },
    LookupTable: {
        compound: false,
        description: "Changes value according to mapping stated in lookup table",
        input_kind: [
            {
                name: "*",
                description: "Equivalent of any element",
                docs: null,
                serialised_data_type: "Any",
                internal_data_type: "Any"
            }
        ],
        output_kind: [
            {
                name: "*",
                description: "Equivalent of any element",
                docs: null,
                serialised_data_type: "Any",
                internal_data_type: "Any"
            }
        ],
        properties: {
            type: { const: "LookupTable", enum: ["LookupTable"], title: "Type", type: "string" },
            lookup_table: { title: "Lookup Table", type: "object" }
        },
        required: ["type", "lookup_table"],
        title: "LookupTable",
        type: "object"
    },
    Multiply: {
        compound: false,
        description: "Multiplication",
        input_kind: [
            {
                name: "integer",
                description: "Integer value",
                docs: null,
                serialised_data_type: "int",
                internal_data_type: "int"
            },
            {
                name: "float",
                description: "Float value",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            },
            {
                name: "float_zero_to_one",
                description: "`float` value in range `[0.0, 1.0]`",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            }
        ],
        output_kind: [
            {
                name: "integer",
                description: "Integer value",
                docs: null,
                serialised_data_type: "int",
                internal_data_type: "int"
            },
            {
                name: "float",
                description: "Float value",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            },
            {
                name: "float_zero_to_one",
                description: "`float` value in range `[0.0, 1.0]`",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            }
        ],
        properties: {
            type: { const: "Multiply", enum: ["Multiply"], title: "Type", type: "string" },
            other: { anyOf: [{ type: "integer" }, { type: "number" }], title: "Other" }
        },
        required: ["type", "other"],
        title: "Multiply",
        display_name: "Multiply",
        display_description: "Multiply the input value by a specified amount.",
        rank: 16,
        type: "object"
    },
    NotEquals: {
        description: "Checks if two values given are not equal",
        operands_kinds: [
            [
                {
                    name: "integer",
                    description: "Integer value",
                    docs: null,
                    serialised_data_type: "int",
                    internal_data_type: "int"
                },
                {
                    name: "string",
                    description: "String value",
                    docs: null,
                    serialised_data_type: "str",
                    internal_data_type: "str"
                },
                {
                    name: "float",
                    description: "Float value",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                },
                {
                    name: "float_zero_to_one",
                    description: "`float` value in range `[0.0, 1.0]`",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                },
                {
                    name: "boolean",
                    description: "Boolean flag",
                    docs: null,
                    serialised_data_type: "bool",
                    internal_data_type: "bool"
                },
                {
                    name: "list_of_values",
                    description: "List of values of any type",
                    docs: null,
                    serialised_data_type: "List[Any]",
                    internal_data_type: "List[Any]"
                }
            ],
            [
                {
                    name: "integer",
                    description: "Integer value",
                    docs: null,
                    serialised_data_type: "int",
                    internal_data_type: "int"
                },
                {
                    name: "string",
                    description: "String value",
                    docs: null,
                    serialised_data_type: "str",
                    internal_data_type: "str"
                },
                {
                    name: "float",
                    description: "Float value",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                },
                {
                    name: "float_zero_to_one",
                    description: "`float` value in range `[0.0, 1.0]`",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                },
                {
                    name: "boolean",
                    description: "Boolean flag",
                    docs: null,
                    serialised_data_type: "bool",
                    internal_data_type: "bool"
                },
                {
                    name: "list_of_values",
                    description: "List of values of any type",
                    docs: null,
                    serialised_data_type: "List[Any]",
                    internal_data_type: "List[Any]"
                }
            ]
        ],
        operands_number: 2,
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: { type: { enum: ["(Number) !=", "!="], title: "Type", type: "string" } },
        required: ["type"],
        title: "NotEquals",
        type: "object"
    },
    NumberCastingMode: { enum: ["int", "float"], title: "NumberCastingMode", type: "string" },
    NumberGreater: {
        description: "Checks if first value (number) is greater than the second value (number)",
        operands_kinds: [
            [
                {
                    name: "integer",
                    description: "Integer value",
                    docs: null,
                    serialised_data_type: "int",
                    internal_data_type: "int"
                },
                {
                    name: "float",
                    description: "Float value",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                },
                {
                    name: "float_zero_to_one",
                    description: "`float` value in range `[0.0, 1.0]`",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                }
            ],
            [
                {
                    name: "integer",
                    description: "Integer value",
                    docs: null,
                    serialised_data_type: "int",
                    internal_data_type: "int"
                },
                {
                    name: "float",
                    description: "Float value",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                },
                {
                    name: "float_zero_to_one",
                    description: "`float` value in range `[0.0, 1.0]`",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                }
            ]
        ],
        operands_number: 2,
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: {
            type: { const: "(Number) >", enum: ["(Number) >"], title: "Type", type: "string" }
        },
        required: ["type"],
        title: "NumberGreater",
        type: "object"
    },
    NumberGreaterEqual: {
        description:
            "Checks if first value (number) is greater or equal than the second value (number)",
        operands_kinds: [
            [
                {
                    name: "integer",
                    description: "Integer value",
                    docs: null,
                    serialised_data_type: "int",
                    internal_data_type: "int"
                },
                {
                    name: "float",
                    description: "Float value",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                },
                {
                    name: "float_zero_to_one",
                    description: "`float` value in range `[0.0, 1.0]`",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                }
            ],
            [
                {
                    name: "integer",
                    description: "Integer value",
                    docs: null,
                    serialised_data_type: "int",
                    internal_data_type: "int"
                },
                {
                    name: "float",
                    description: "Float value",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                },
                {
                    name: "float_zero_to_one",
                    description: "`float` value in range `[0.0, 1.0]`",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                }
            ]
        ],
        operands_number: 2,
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: {
            type: { const: "(Number) >=", enum: ["(Number) >="], title: "Type", type: "string" }
        },
        required: ["type"],
        title: "NumberGreaterEqual",
        type: "object"
    },
    NumberLower: {
        description: "Checks if first value (number) is lower than the second value (number)",
        operands_kinds: [
            [
                {
                    name: "integer",
                    description: "Integer value",
                    docs: null,
                    serialised_data_type: "int",
                    internal_data_type: "int"
                },
                {
                    name: "float",
                    description: "Float value",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                },
                {
                    name: "float_zero_to_one",
                    description: "`float` value in range `[0.0, 1.0]`",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                }
            ],
            [
                {
                    name: "integer",
                    description: "Integer value",
                    docs: null,
                    serialised_data_type: "int",
                    internal_data_type: "int"
                },
                {
                    name: "float",
                    description: "Float value",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                },
                {
                    name: "float_zero_to_one",
                    description: "`float` value in range `[0.0, 1.0]`",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                }
            ]
        ],
        operands_number: 2,
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: {
            type: { const: "(Number) <", enum: ["(Number) <"], title: "Type", type: "string" }
        },
        required: ["type"],
        title: "NumberLower",
        type: "object"
    },
    NumberLowerEqual: {
        description:
            "Checks if first value (number) is lower or equal than the second value (number)",
        operands_kinds: [
            [
                {
                    name: "integer",
                    description: "Integer value",
                    docs: null,
                    serialised_data_type: "int",
                    internal_data_type: "int"
                },
                {
                    name: "float",
                    description: "Float value",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                },
                {
                    name: "float_zero_to_one",
                    description: "`float` value in range `[0.0, 1.0]`",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                }
            ],
            [
                {
                    name: "integer",
                    description: "Integer value",
                    docs: null,
                    serialised_data_type: "int",
                    internal_data_type: "int"
                },
                {
                    name: "float",
                    description: "Float value",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                },
                {
                    name: "float_zero_to_one",
                    description: "`float` value in range `[0.0, 1.0]`",
                    docs: null,
                    serialised_data_type: "float",
                    internal_data_type: "float"
                }
            ]
        ],
        operands_number: 2,
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: {
            type: { const: "(Number) <=", enum: ["(Number) <="], title: "Type", type: "string" }
        },
        required: ["type"],
        title: "NumberLowerEqual",
        type: "object"
    },
    NumberRound: {
        compound: false,
        description: "Rounds the number",
        input_kind: [
            {
                name: "integer",
                description: "Integer value",
                docs: null,
                serialised_data_type: "int",
                internal_data_type: "int"
            },
            {
                name: "float",
                description: "Float value",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            },
            {
                name: "float_zero_to_one",
                description: "`float` value in range `[0.0, 1.0]`",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            }
        ],
        output_kind: [
            {
                name: "integer",
                description: "Integer value",
                docs: null,
                serialised_data_type: "int",
                internal_data_type: "int"
            },
            {
                name: "float",
                description: "Float value",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            },
            {
                name: "float_zero_to_one",
                description: "`float` value in range `[0.0, 1.0]`",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            }
        ],
        properties: {
            type: { const: "NumberRound", enum: ["NumberRound"], title: "Type", type: "string" },
            decimal_digits: { title: "Decimal Digits", type: "integer" }
        },
        required: ["type", "decimal_digits"],
        title: "NumberRound",
        display_name: "Round Number",
        display_description: "Round the input number to the specified number of decimal digits.",
        rank: 15,
        type: "object"
    },
    NumericSequenceAggregate: {
        compound: false,
        description:
            "Aggregates numeric sequence using aggregation function like min or max - adjusted to work on numbers",
        input_kind: [
            {
                name: "list_of_values",
                description: "List of values of any type",
                docs: null,
                serialised_data_type: "List[Any]",
                internal_data_type: "List[Any]"
            }
        ],
        output_kind: [
            {
                name: "integer",
                description: "Integer value",
                docs: null,
                serialised_data_type: "int",
                internal_data_type: "int"
            },
            {
                name: "float",
                description: "Float value",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            },
            {
                name: "float_zero_to_one",
                description: "`float` value in range `[0.0, 1.0]`",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            }
        ],
        properties: {
            type: {
                const: "NumericSequenceAggregate",
                enum: ["NumericSequenceAggregate"],
                title: "Type",
                type: "string"
            },
            function: { $ref: "#/$defs/SequenceAggregationFunction" },
            neutral_value: { default: null, title: "Neutral Value" }
        },
        required: ["type", "function"],
        title: "NumericSequenceAggregate",
        display_name: "Extract Numeric Sequence Property",
        display_description:
            "Extract a property from the numeric sequence, such as the min or max element.",
        rank: 8,
        type: "object"
    },
    RandomNumber: {
        description:
            "Special operation to let random sampling - ignoring input data and changing it into random floating point value. To be used mainly to sample predictions or images.",
        input_kind: [
            {
                name: "object_detection_prediction",
                description:
                    "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "instance_segmentation_prediction",
                description:
                    "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "keypoint_detection_prediction",
                description:
                    "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "*",
                description: "Equivalent of any element",
                docs: null,
                serialised_data_type: "Any",
                internal_data_type: "Any"
            }
        ],
        output_kind: [
            {
                name: "float",
                description: "Float value",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            },
            {
                name: "float_zero_to_one",
                description: "`float` value in range `[0.0, 1.0]`",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            }
        ],
        properties: {
            type: { const: "RandomNumber", enum: ["RandomNumber"], title: "Type", type: "string" },
            min_value: { default: 0, title: "Min Value", type: "number" },
            max_value: { default: 1, title: "Max Value", type: "number" }
        },
        required: ["type"],
        title: "RandomNumber",
        display_name: "Random Number",
        display_description:
            "Generate a random number between the specified minimum and maximum values.",
        rank: 50,
        type: "object"
    },
    SequenceAggregate: {
        compound: false,
        description:
            "Aggregates sequence using generic aggregation methods - adjusted to majority data types",
        input_kind: [
            {
                name: "list_of_values",
                description: "List of values of any type",
                docs: null,
                serialised_data_type: "List[Any]",
                internal_data_type: "List[Any]"
            }
        ],
        output_kind: [
            {
                name: "*",
                description: "Equivalent of any element",
                docs: null,
                serialised_data_type: "Any",
                internal_data_type: "Any"
            }
        ],
        properties: {
            type: {
                const: "SequenceAggregate",
                enum: ["SequenceAggregate"],
                title: "Type",
                type: "string"
            },
            mode: { $ref: "#/$defs/SequenceAggregationMode" }
        },
        required: ["type", "mode"],
        title: "SequenceAggregate",
        display_name: "Extract Sequence Property",
        display_description:
            "Extract a property from the sequence, such as the first or most common element.",
        rank: 7,
        type: "object"
    },
    SequenceAggregationFunction: {
        enum: ["min", "max"],
        title: "SequenceAggregationFunction",
        type: "string"
    },
    SequenceAggregationMode: {
        enum: ["first", "last", "most_common", "least_common"],
        title: "SequenceAggregationMode",
        type: "string"
    },
    SequenceApply: {
        compound: true,
        description: "Operation applies chain of operations at every element of sequence",
        input_kind: [
            {
                name: "list_of_values",
                description: "List of values of any type",
                docs: null,
                serialised_data_type: "List[Any]",
                internal_data_type: "List[Any]"
            }
        ],
        nested_operation_input_kind: [
            {
                name: "*",
                description: "Equivalent of any element",
                docs: null,
                serialised_data_type: "Any",
                internal_data_type: "Any"
            }
        ],
        nested_operation_output_kind: [
            {
                name: "*",
                description: "Equivalent of any element",
                docs: null,
                serialised_data_type: "Any",
                internal_data_type: "Any"
            }
        ],
        output_kind: [
            {
                name: "list_of_values",
                description: "List of values of any type",
                docs: null,
                serialised_data_type: "List[Any]",
                internal_data_type: "List[Any]"
            }
        ],
        properties: {
            type: {
                const: "SequenceApply",
                enum: ["SequenceApply"],
                title: "Type",
                type: "string"
            },
            operations: {
                items: {
                    discriminator: {
                        mapping: {
                            ClassificationPropertyExtract: "#/$defs/ClassificationPropertyExtract",
                            ConvertDictionaryToJSON: "#/$defs/ConvertDictionaryToJSON",
                            ConvertImageToBase64: "#/$defs/ConvertImageToBase64",
                            ConvertImageToJPEG: "#/$defs/ConvertImageToJPEG",
                            DetectionsFilter: "#/$defs/DetectionsFilter",
                            DetectionsOffset: "#/$defs/DetectionsOffset",
                            DetectionsPropertyExtract: "#/$defs/DetectionsPropertyExtract",
                            DetectionsRename: "#/$defs/DetectionsRename",
                            DetectionsSelection: "#/$defs/DetectionsSelection",
                            DetectionsShift: "#/$defs/DetectionsShift",
                            DetectionsToDictionary: "#/$defs/DetectionsToDictionary",
                            Divide: "#/$defs/Divide",
                            ExtractDetectionProperty: "#/$defs/ExtractDetectionProperty",
                            ExtractImageProperty: "#/$defs/ExtractImageProperty",
                            LookupTable: "#/$defs/LookupTable",
                            Multiply: "#/$defs/Multiply",
                            NumberRound: "#/$defs/NumberRound",
                            NumericSequenceAggregate: "#/$defs/NumericSequenceAggregate",
                            RandomNumber: "#/$defs/RandomNumber",
                            SequenceAggregate: "#/$defs/SequenceAggregate",
                            SequenceApply: "#/$defs/SequenceApply",
                            SequenceLength: "#/$defs/SequenceLength",
                            SequenceMap: "#/$defs/SequenceMap",
                            SortDetections: "#/$defs/SortDetections",
                            StringMatches: "#/$defs/StringMatches",
                            StringSubSequence: "#/$defs/StringSubSequence",
                            StringToLowerCase: "#/$defs/StringToLowerCase",
                            StringToUpperCase: "#/$defs/StringToUpperCase",
                            ToBoolean: "#/$defs/ToBoolean",
                            ToNumber: "#/$defs/ToNumber",
                            ToString: "#/$defs/ToString"
                        },
                        propertyName: "type"
                    },
                    oneOf: [
                        { $ref: "#/$defs/StringToLowerCase" },
                        { $ref: "#/$defs/StringToUpperCase" },
                        { $ref: "#/$defs/LookupTable" },
                        { $ref: "#/$defs/ToNumber" },
                        { $ref: "#/$defs/NumberRound" },
                        { $ref: "#/$defs/SequenceMap" },
                        { $ref: "#/$defs/SequenceApply" },
                        { $ref: "#/$defs/NumericSequenceAggregate" },
                        { $ref: "#/$defs/ToString" },
                        { $ref: "#/$defs/ToBoolean" },
                        { $ref: "#/$defs/StringSubSequence" },
                        { $ref: "#/$defs/DetectionsPropertyExtract" },
                        { $ref: "#/$defs/SequenceAggregate" },
                        { $ref: "#/$defs/ExtractDetectionProperty" },
                        { $ref: "#/$defs/DetectionsFilter" },
                        { $ref: "#/$defs/DetectionsOffset" },
                        { $ref: "#/$defs/DetectionsShift" },
                        { $ref: "#/$defs/DetectionsRename" },
                        { $ref: "#/$defs/RandomNumber" },
                        { $ref: "#/$defs/StringMatches" },
                        { $ref: "#/$defs/ExtractImageProperty" },
                        { $ref: "#/$defs/SequenceLength" },
                        { $ref: "#/$defs/Multiply" },
                        { $ref: "#/$defs/Divide" },
                        { $ref: "#/$defs/DetectionsSelection" },
                        { $ref: "#/$defs/SortDetections" },
                        { $ref: "#/$defs/ClassificationPropertyExtract" },
                        { $ref: "#/$defs/ConvertImageToJPEG" },
                        { $ref: "#/$defs/ConvertImageToBase64" },
                        { $ref: "#/$defs/DetectionsToDictionary" },
                        { $ref: "#/$defs/ConvertDictionaryToJSON" }
                    ]
                },
                title: "Operations",
                type: "array"
            }
        },
        required: ["type", "operations"],
        title: "SequenceApply",
        type: "object"
    },
    SequenceLength: {
        compound: false,
        description: "Operation determines the length of input sequence",
        input_kind: [
            {
                name: "object_detection_prediction",
                description:
                    "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "instance_segmentation_prediction",
                description:
                    "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "keypoint_detection_prediction",
                description:
                    "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "list_of_values",
                description: "List of values of any type",
                docs: null,
                serialised_data_type: "List[Any]",
                internal_data_type: "List[Any]"
            },
            {
                name: "dictionary",
                description: "Dictionary",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "dict"
            }
        ],
        output_kind: [
            {
                name: "integer",
                description: "Integer value",
                docs: null,
                serialised_data_type: "int",
                internal_data_type: "int"
            }
        ],
        properties: {
            type: {
                const: "SequenceLength",
                enum: ["SequenceLength"],
                title: "Type",
                type: "string"
            }
        },
        required: ["type"],
        title: "SequenceLength",
        display_name: "Count Items",
        display_description: "Count the number of items in the provided list.",
        rank: 2,
        type: "object"
    },
    SequenceElementsCount: {
        compound: false,
        description: "Operation counts number of occurences of unique elements of sequence",
        input_kind: [
            {
                name: "list_of_values",
                description: "List of values of any type",
                docs: null,
                serialised_data_type: "List[Any]",
                internal_data_type: "List[Any]"
            }
        ],
        output_kind: [
            {
                name: "dictionary",
                description: "Dictionary",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "dict"
            }
        ],
        properties: {
            type: {
                const: "SequenceElementsCount",
                enum: ["SequenceElementsCount"],
                title: "Type",
                type: "string"
            }
        },
        required: ["type"],
        title: "SequenceElementsCount",
        display_name: "Count Unique Items",
        display_description: "Count number of occurences of unique elements of the sequence.",
        rank: 2,
        type: "object"
    },
    SequenceMap: {
        compound: true,
        description: "Changes each value of sequence according to mapping stated in lookup table",
        input_kind: [
            {
                name: "list_of_values",
                description: "List of values of any type",
                docs: null,
                serialised_data_type: "List[Any]",
                internal_data_type: "List[Any]"
            }
        ],
        nested_operation_input_kind: [
            {
                name: "*",
                description: "Equivalent of any element",
                docs: null,
                serialised_data_type: "Any",
                internal_data_type: "Any"
            }
        ],
        nested_operation_output_kind: [
            {
                name: "*",
                description: "Equivalent of any element",
                docs: null,
                serialised_data_type: "Any",
                internal_data_type: "Any"
            }
        ],
        output_kind: [
            {
                name: "list_of_values",
                description: "List of values of any type",
                docs: null,
                serialised_data_type: "List[Any]",
                internal_data_type: "List[Any]"
            }
        ],
        properties: {
            type: { const: "SequenceMap", enum: ["SequenceMap"], title: "Type", type: "string" },
            lookup_table: { title: "Lookup Table", type: "object" }
        },
        required: ["type", "lookup_table"],
        title: "SequenceMap",
        type: "object"
    },
    SortDetections: {
        compound: false,
        description: "Changes the order of detected bounding boxes.",
        input_kind: [
            {
                name: "object_detection_prediction",
                description:
                    "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "instance_segmentation_prediction",
                description:
                    "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "keypoint_detection_prediction",
                description:
                    "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            }
        ],
        output_kind: [
            {
                name: "object_detection_prediction",
                description:
                    "Prediction with detected bounding boxes in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "instance_segmentation_prediction",
                description:
                    "Prediction with detected bounding boxes and segmentation masks in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            },
            {
                name: "keypoint_detection_prediction",
                description:
                    "Prediction with detected bounding boxes and detected keypoints in form of sv.Detections(...) object",
                docs: null,
                serialised_data_type: "dict",
                internal_data_type: "sv.Detections"
            }
        ],
        properties: {
            type: {
                const: "SortDetections",
                enum: ["SortDetections"],
                title: "Type",
                type: "string"
            },
            mode: { $ref: "#/$defs/DetectionsSortProperties" },
            ascending: { default: true, title: "Ascending", type: "boolean" }
        },
        required: ["type", "mode"],
        title: "SortDetections",
        display_name: "Sort Detections",
        display_description: "Sort predictions by a specified property.",
        rank: 5,
        type: "object"
    },
    StatementGroup: {
        properties: {
            type: {
                const: "StatementGroup",
                enum: ["StatementGroup"],
                title: "Type",
                type: "string"
            },
            statements: {
                items: {
                    discriminator: {
                        mapping: {
                            BinaryStatement: "#/$defs/BinaryStatement",
                            StatementGroup: "#/$defs/StatementGroup",
                            UnaryStatement: "#/$defs/UnaryStatement"
                        },
                        propertyName: "type"
                    },
                    oneOf: [
                        { $ref: "#/$defs/BinaryStatement" },
                        { $ref: "#/$defs/UnaryStatement" },
                        { $ref: "#/$defs/StatementGroup" }
                    ]
                },
                minItems: 1,
                title: "Statements",
                type: "array"
            },
            operator: { $ref: "#/$defs/StatementsGroupsOperator", default: "or" }
        },
        required: ["type", "statements"],
        title: "StatementGroup",
        type: "object"
    },
    StatementsGroupsOperator: {
        enum: ["and", "or"],
        title: "StatementsGroupsOperator",
        type: "string"
    },
    StaticCaseResult: {
        properties: {
            type: {
                const: "StaticCaseResult",
                enum: ["StaticCaseResult"],
                title: "Type",
                type: "string"
            },
            value: { title: "Value" }
        },
        required: ["type", "value"],
        title: "StaticCaseResult",
        type: "object"
    },
    StaticOperand: {
        properties: {
            type: {
                const: "StaticOperand",
                enum: ["StaticOperand"],
                title: "Type",
                type: "string"
            },
            value: { title: "Value" },
            operations: {
                items: {
                    discriminator: {
                        mapping: {
                            ClassificationPropertyExtract: "#/$defs/ClassificationPropertyExtract",
                            ConvertDictionaryToJSON: "#/$defs/ConvertDictionaryToJSON",
                            ConvertImageToBase64: "#/$defs/ConvertImageToBase64",
                            ConvertImageToJPEG: "#/$defs/ConvertImageToJPEG",
                            DetectionsFilter: "#/$defs/DetectionsFilter",
                            DetectionsOffset: "#/$defs/DetectionsOffset",
                            DetectionsPropertyExtract: "#/$defs/DetectionsPropertyExtract",
                            DetectionsRename: "#/$defs/DetectionsRename",
                            DetectionsSelection: "#/$defs/DetectionsSelection",
                            DetectionsShift: "#/$defs/DetectionsShift",
                            DetectionsToDictionary: "#/$defs/DetectionsToDictionary",
                            Divide: "#/$defs/Divide",
                            ExtractDetectionProperty: "#/$defs/ExtractDetectionProperty",
                            ExtractImageProperty: "#/$defs/ExtractImageProperty",
                            LookupTable: "#/$defs/LookupTable",
                            Multiply: "#/$defs/Multiply",
                            NumberRound: "#/$defs/NumberRound",
                            NumericSequenceAggregate: "#/$defs/NumericSequenceAggregate",
                            RandomNumber: "#/$defs/RandomNumber",
                            SequenceAggregate: "#/$defs/SequenceAggregate",
                            SequenceApply: "#/$defs/SequenceApply",
                            SequenceLength: "#/$defs/SequenceLength",
                            SequenceMap: "#/$defs/SequenceMap",
                            SortDetections: "#/$defs/SortDetections",
                            StringMatches: "#/$defs/StringMatches",
                            StringSubSequence: "#/$defs/StringSubSequence",
                            StringToLowerCase: "#/$defs/StringToLowerCase",
                            StringToUpperCase: "#/$defs/StringToUpperCase",
                            ToBoolean: "#/$defs/ToBoolean",
                            ToNumber: "#/$defs/ToNumber",
                            ToString: "#/$defs/ToString"
                        },
                        propertyName: "type"
                    },
                    oneOf: [
                        { $ref: "#/$defs/StringToLowerCase" },
                        { $ref: "#/$defs/StringToUpperCase" },
                        { $ref: "#/$defs/LookupTable" },
                        { $ref: "#/$defs/ToNumber" },
                        { $ref: "#/$defs/NumberRound" },
                        { $ref: "#/$defs/SequenceMap" },
                        { $ref: "#/$defs/SequenceApply" },
                        { $ref: "#/$defs/NumericSequenceAggregate" },
                        { $ref: "#/$defs/ToString" },
                        { $ref: "#/$defs/ToBoolean" },
                        { $ref: "#/$defs/StringSubSequence" },
                        { $ref: "#/$defs/DetectionsPropertyExtract" },
                        { $ref: "#/$defs/SequenceAggregate" },
                        { $ref: "#/$defs/ExtractDetectionProperty" },
                        { $ref: "#/$defs/DetectionsFilter" },
                        { $ref: "#/$defs/DetectionsOffset" },
                        { $ref: "#/$defs/DetectionsShift" },
                        { $ref: "#/$defs/DetectionsRename" },
                        { $ref: "#/$defs/RandomNumber" },
                        { $ref: "#/$defs/StringMatches" },
                        { $ref: "#/$defs/ExtractImageProperty" },
                        { $ref: "#/$defs/SequenceLength" },
                        { $ref: "#/$defs/Multiply" },
                        { $ref: "#/$defs/Divide" },
                        { $ref: "#/$defs/DetectionsSelection" },
                        { $ref: "#/$defs/SortDetections" },
                        { $ref: "#/$defs/ClassificationPropertyExtract" },
                        { $ref: "#/$defs/ConvertImageToJPEG" },
                        { $ref: "#/$defs/ConvertImageToBase64" },
                        { $ref: "#/$defs/DetectionsToDictionary" },
                        { $ref: "#/$defs/ConvertDictionaryToJSON" }
                    ]
                },
                title: "Operations",
                type: "array"
            }
        },
        required: ["type", "value"],
        title: "StaticOperand",
        type: "object"
    },
    StringContains: {
        description:
            "Checks if string given as first value contains string provided as second value",
        operands_kinds: [
            [
                {
                    name: "string",
                    description: "String value",
                    docs: null,
                    serialised_data_type: "str",
                    internal_data_type: "str"
                }
            ],
            [
                {
                    name: "string",
                    description: "String value",
                    docs: null,
                    serialised_data_type: "str",
                    internal_data_type: "str"
                }
            ]
        ],
        operands_number: 2,
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: {
            type: {
                const: "(String) contains",
                enum: ["(String) contains"],
                title: "Type",
                type: "string"
            }
        },
        required: ["type"],
        title: "StringContains",
        type: "object"
    },
    StringEndsWith: {
        description:
            "Checks if string given as first value ends with string provided as second value",
        operands_kinds: [
            [
                {
                    name: "string",
                    description: "String value",
                    docs: null,
                    serialised_data_type: "str",
                    internal_data_type: "str"
                }
            ],
            [
                {
                    name: "string",
                    description: "String value",
                    docs: null,
                    serialised_data_type: "str",
                    internal_data_type: "str"
                }
            ]
        ],
        operands_number: 2,
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: {
            type: {
                const: "(String) endsWith",
                enum: ["(String) endsWith"],
                title: "Type",
                type: "string"
            }
        },
        required: ["type"],
        title: "StringEndsWith",
        type: "object"
    },
    StringMatches: {
        compound: false,
        description: "Checks if string matches regex",
        input_kind: [
            {
                name: "string",
                description: "String value",
                docs: null,
                serialised_data_type: "str",
                internal_data_type: "str"
            }
        ],
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: {
            type: {
                const: "StringMatches",
                enum: ["StringMatches"],
                title: "Type",
                type: "string"
            },
            regex: { title: "Regex", type: "string" }
        },
        required: ["type", "regex"],
        title: "StringMatches",
        display_name: "Regex Match",
        display_description: "Check if the string matches the regex pattern, returns a boolean.",
        rank: 6,
        type: "object"
    },
    StringStartsWith: {
        description:
            "Checks if string given as first value starts with string provided as second value",
        operands_kinds: [
            [
                {
                    name: "string",
                    description: "String value",
                    docs: null,
                    serialised_data_type: "str",
                    internal_data_type: "str"
                }
            ],
            [
                {
                    name: "string",
                    description: "String value",
                    docs: null,
                    serialised_data_type: "str",
                    internal_data_type: "str"
                }
            ]
        ],
        operands_number: 2,
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: {
            type: {
                const: "(String) startsWith",
                enum: ["(String) startsWith"],
                title: "Type",
                type: "string"
            }
        },
        required: ["type"],
        title: "StringStartsWith",
        type: "object"
    },
    StringSubSequence: {
        compound: false,
        description: "Takes sub-string of the input string",
        input_kind: [
            {
                name: "string",
                description: "String value",
                docs: null,
                serialised_data_type: "str",
                internal_data_type: "str"
            }
        ],
        output_kind: [
            {
                name: "string",
                description: "String value",
                docs: null,
                serialised_data_type: "str",
                internal_data_type: "str"
            }
        ],
        properties: {
            type: {
                const: "StringSubSequence",
                enum: ["StringSubSequence"],
                title: "Type",
                type: "string"
            },
            start: { default: 0, title: "Start", type: "integer" },
            end: { default: -1, title: "End", type: "integer" }
        },
        required: ["type"],
        title: "StringSubSequence",
        display_name: "Extract Substring",
        display_description: "Extract a substring from the input string.",
        rank: 8,
        type: "object"
    },
    StringToLowerCase: {
        compound: false,
        description: "Executes lowercase operation on input string",
        input_kind: [
            {
                name: "string",
                description: "String value",
                docs: null,
                serialised_data_type: "str",
                internal_data_type: "str"
            }
        ],
        output_kind: [
            {
                name: "string",
                description: "String value",
                docs: null,
                serialised_data_type: "str",
                internal_data_type: "str"
            }
        ],
        properties: {
            type: {
                const: "StringToLowerCase",
                enum: ["StringToLowerCase"],
                title: "Type",
                type: "string"
            }
        },
        required: ["type"],
        title: "StringToLowerCase",
        display_name: "Convert to Lowercase",
        display_description: "Convert the input string to lowercase letters.",
        rank: 10,
        type: "object"
    },
    StringToUpperCase: {
        compound: false,
        description: "Executes uppercase operation on input string",
        input_kind: [
            {
                name: "string",
                description: "String value",
                docs: null,
                serialised_data_type: "str",
                internal_data_type: "str"
            }
        ],
        output_kind: [
            {
                name: "string",
                description: "String value",
                docs: null,
                serialised_data_type: "str",
                internal_data_type: "str"
            }
        ],
        properties: {
            type: {
                const: "StringToUpperCase",
                enum: ["StringToUpperCase"],
                title: "Type",
                type: "string"
            }
        },
        required: ["type"],
        title: "StringToUpperCase",
        display_name: "Convert to Uppercase",
        display_description: "Convert the input string to uppercase letters.",
        rank: 10,
        type: "object"
    },
    ToBoolean: {
        compound: false,
        description: "Changes input data into boolean",
        input_kind: [
            {
                name: "float",
                description: "Float value",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            },
            {
                name: "float_zero_to_one",
                description: "`float` value in range `[0.0, 1.0]`",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            },
            {
                name: "integer",
                description: "Integer value",
                docs: null,
                serialised_data_type: "int",
                internal_data_type: "int"
            }
        ],
        output_kind: [
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            }
        ],
        properties: {
            type: { const: "ToBoolean", enum: ["ToBoolean"], title: "Type", type: "string" }
        },
        required: ["type"],
        title: "ToBoolean",
        display_name: "Convert to Boolean",
        display_description: "Convert the input value to a boolean.",
        rank: 10,
        type: "object"
    },
    ToNumber: {
        compound: false,
        description: "Changes value into number - float or int depending on configuration",
        input_kind: [
            {
                name: "string",
                description: "String value",
                docs: null,
                serialised_data_type: "str",
                internal_data_type: "str"
            },
            {
                name: "boolean",
                description: "Boolean flag",
                docs: null,
                serialised_data_type: "bool",
                internal_data_type: "bool"
            },
            {
                name: "integer",
                description: "Integer value",
                docs: null,
                serialised_data_type: "int",
                internal_data_type: "int"
            },
            {
                name: "float",
                description: "Float value",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            },
            {
                name: "float_zero_to_one",
                description: "`float` value in range `[0.0, 1.0]`",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            }
        ],
        output_kind: [
            {
                name: "integer",
                description: "Integer value",
                docs: null,
                serialised_data_type: "int",
                internal_data_type: "int"
            },
            {
                name: "float",
                description: "Float value",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            },
            {
                name: "float_zero_to_one",
                description: "`float` value in range `[0.0, 1.0]`",
                docs: null,
                serialised_data_type: "float",
                internal_data_type: "float"
            }
        ],
        properties: {
            type: { const: "ToNumber", enum: ["ToNumber"], title: "Type", type: "string" },
            cast_to: { $ref: "#/$defs/NumberCastingMode" }
        },
        required: ["type", "cast_to"],
        title: "ToNumber",
        display_name: "Convert to Number",
        display_description: "Convert the input value to a number.",
        rank: 10,
        type: "object"
    },
    ToString: {
        compound: false,
        description: "Stringifies data",
        input_kind: [
            {
                name: "*",
                description: "Equivalent of any element",
                docs: null,
                serialised_data_type: "Any",
                internal_data_type: "Any"
            }
        ],
        output_kind: [
            {
                name: "string",
                description: "String value",
                docs: null,
                serialised_data_type: "str",
                internal_data_type: "str"
            }
        ],
        properties: {
            type: { const: "ToString", enum: ["ToString"], title: "Type", type: "string" }
        },
        required: ["type"],
        title: "ToString",
        display_name: "Convert to String",
        display_description: "Convert the input value to a string.",
        rank: 12,
        type: "object"
    },
    UnaryStatement: {
        properties: {
            type: {
                const: "UnaryStatement",
                enum: ["UnaryStatement"],
                title: "Type",
                type: "string"
            },
            operand: {
                discriminator: {
                    mapping: {
                        DynamicOperand: "#/$defs/DynamicOperand",
                        StaticOperand: "#/$defs/StaticOperand"
                    },
                    propertyName: "type"
                },
                oneOf: [{ $ref: "#/$defs/StaticOperand" }, { $ref: "#/$defs/DynamicOperand" }],
                title: "Operand"
            },
            operator: {
                discriminator: {
                    mapping: {
                        "(Boolean) is False": "#/$defs/IsFalse",
                        "(Boolean) is True": "#/$defs/IsTrue",
                        "(Sequence) is empty": "#/$defs/IsEmpty",
                        "(Sequence) is not empty": "#/$defs/IsNotEmpty",
                        "DoesNotExist": "#/$defs/DoesNotExist",
                        "Exists": "#/$defs/Exists"
                    },
                    propertyName: "type"
                },
                oneOf: [
                    { $ref: "#/$defs/Exists" },
                    { $ref: "#/$defs/DoesNotExist" },
                    { $ref: "#/$defs/IsTrue" },
                    { $ref: "#/$defs/IsFalse" },
                    { $ref: "#/$defs/IsEmpty" },
                    { $ref: "#/$defs/IsNotEmpty" }
                ],
                title: "Operator"
            },
            negate: { default: false, title: "Negate", type: "boolean" }
        },
        required: ["type", "operand", "operator"],
        title: "UnaryStatement",
        type: "object"
    }
};

const uqlCondensedSchema = {
    operations_description: [
        {
            operation_type: "StringToLowerCase",
            compound: false,
            input_kind: ["string"],
            output_kind: ["string"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "StringToUpperCase",
            compound: false,
            input_kind: ["string"],
            output_kind: ["string"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "LookupTable",
            compound: false,
            input_kind: ["*"],
            output_kind: ["*"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "ToNumber",
            compound: false,
            input_kind: ["string", "boolean", "integer", "float", "float_zero_to_one"],
            output_kind: ["integer", "float", "float_zero_to_one"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "NumberRound",
            compound: false,
            input_kind: ["integer", "float", "float_zero_to_one"],
            output_kind: ["integer", "float", "float_zero_to_one"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "SequenceMap",
            compound: true,
            input_kind: ["list_of_values"],
            output_kind: ["list_of_values"],
            nested_operation_input_kind: ["*"],
            nested_operation_output_kind: ["*"],
            description: null
        },
        {
            operation_type: "SequenceApply",
            compound: true,
            input_kind: ["list_of_values"],
            output_kind: ["list_of_values"],
            nested_operation_input_kind: ["*"],
            nested_operation_output_kind: ["*"],
            description: null
        },
        {
            operation_type: "NumericSequenceAggregate",
            compound: false,
            input_kind: ["list_of_values"],
            output_kind: ["integer", "float", "float_zero_to_one"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "ToString",
            compound: false,
            input_kind: ["*"],
            output_kind: ["string"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "ToBoolean",
            compound: false,
            input_kind: ["float", "float_zero_to_one", "integer"],
            output_kind: ["boolean"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "StringSubSequence",
            compound: false,
            input_kind: ["string"],
            output_kind: ["string"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "DetectionsPropertyExtract",
            compound: false,
            input_kind: [
                "object_detection_prediction",
                "instance_segmentation_prediction",
                "keypoint_detection_prediction"
            ],
            output_kind: ["list_of_values"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "SequenceAggregate",
            compound: false,
            input_kind: ["list_of_values"],
            output_kind: ["*"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "ExtractDetectionProperty",
            compound: false,
            input_kind: ["detection"],
            output_kind: ["*"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "DetectionsFilter",
            compound: true,
            input_kind: [
                "object_detection_prediction",
                "instance_segmentation_prediction",
                "keypoint_detection_prediction"
            ],
            output_kind: [
                "object_detection_prediction",
                "instance_segmentation_prediction",
                "keypoint_detection_prediction"
            ],
            nested_operation_input_kind: ["detection"],
            nested_operation_output_kind: ["boolean"],
            description: null
        },
        {
            operation_type: "DetectionsOffset",
            compound: false,
            input_kind: [
                "object_detection_prediction",
                "instance_segmentation_prediction",
                "keypoint_detection_prediction"
            ],
            output_kind: [
                "object_detection_prediction",
                "instance_segmentation_prediction",
                "keypoint_detection_prediction"
            ],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "DetectionsShift",
            compound: false,
            input_kind: [
                "object_detection_prediction",
                "instance_segmentation_prediction",
                "keypoint_detection_prediction"
            ],
            output_kind: [
                "object_detection_prediction",
                "instance_segmentation_prediction",
                "keypoint_detection_prediction"
            ],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "DetectionsRename",
            compound: false,
            input_kind: [
                "object_detection_prediction",
                "instance_segmentation_prediction",
                "keypoint_detection_prediction"
            ],
            output_kind: [
                "object_detection_prediction",
                "instance_segmentation_prediction",
                "keypoint_detection_prediction"
            ],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "RandomNumber",
            compound: false,
            input_kind: [
                "object_detection_prediction",
                "instance_segmentation_prediction",
                "keypoint_detection_prediction",
                "*"
            ],
            output_kind: ["float", "float_zero_to_one"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "StringMatches",
            compound: false,
            input_kind: ["string"],
            output_kind: ["boolean"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "ExtractImageProperty",
            compound: false,
            input_kind: ["image"],
            output_kind: ["integer"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "SequenceLength",
            compound: false,
            input_kind: [
                "object_detection_prediction",
                "instance_segmentation_prediction",
                "keypoint_detection_prediction",
                "list_of_values",
                "dictionary"
            ],
            output_kind: ["integer"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "Multiply",
            compound: false,
            input_kind: ["integer", "float", "float_zero_to_one"],
            output_kind: ["integer", "float", "float_zero_to_one"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "Divide",
            compound: false,
            input_kind: ["integer", "float", "float_zero_to_one"],
            output_kind: ["integer", "float", "float_zero_to_one"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "DetectionsSelection",
            compound: false,
            input_kind: [
                "object_detection_prediction",
                "instance_segmentation_prediction",
                "keypoint_detection_prediction"
            ],
            output_kind: [
                "object_detection_prediction",
                "instance_segmentation_prediction",
                "keypoint_detection_prediction"
            ],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "SortDetections",
            compound: false,
            input_kind: [
                "object_detection_prediction",
                "instance_segmentation_prediction",
                "keypoint_detection_prediction"
            ],
            output_kind: [
                "object_detection_prediction",
                "instance_segmentation_prediction",
                "keypoint_detection_prediction"
            ],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "ClassificationPropertyExtract",
            compound: false,
            input_kind: ["classification_prediction"],
            output_kind: ["string", "list_of_values", "float_zero_to_one"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "ConvertImageToJPEG",
            compound: false,
            input_kind: ["image"],
            output_kind: ["bytes"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "ConvertImageToBase64",
            compound: false,
            input_kind: ["image"],
            output_kind: ["string"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "DetectionsToDictionary",
            compound: false,
            input_kind: [
                "object_detection_prediction",
                "instance_segmentation_prediction",
                "keypoint_detection_prediction"
            ],
            output_kind: ["dictionary"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        },
        {
            operation_type: "ConvertDictionaryToJSON",
            compound: false,
            input_kind: ["dictionary"],
            output_kind: ["string"],
            nested_operation_input_kind: null,
            nested_operation_output_kind: null,
            description: null
        }
    ],
    operators_descriptions: [
        {
            operator_type: "in (Sequence)",
            operands_number: 2,
            operands_kinds: [
                ["string", "integer", "float", "float_zero_to_one"],
                ["list_of_values", "dictionary"]
            ],
            description:
                "Checks if first value is element of second value (usually list or dictionary)"
        },
        {
            operator_type: "(String) contains",
            operands_number: 2,
            operands_kinds: [["string"], ["string"]],
            description:
                "Checks if string given as first value contains string provided as second value"
        },
        {
            operator_type: "(String) endsWith",
            operands_number: 2,
            operands_kinds: [["string"], ["string"]],
            description:
                "Checks if string given as first value ends with string provided as second value"
        },
        {
            operator_type: "(String) startsWith",
            operands_number: 2,
            operands_kinds: [["string"], ["string"]],
            description:
                "Checks if string given as first value starts with string provided as second value"
        },
        {
            operator_type: "(Number) \u003C=",
            operands_number: 2,
            operands_kinds: [
                ["integer", "float", "float_zero_to_one"],
                ["integer", "float", "float_zero_to_one"]
            ],
            description:
                "Checks if first value (number) is lower or equal than the second value (number)"
        },
        {
            operator_type: "(Number) \u003C",
            operands_number: 2,
            operands_kinds: [
                ["integer", "float", "float_zero_to_one"],
                ["integer", "float", "float_zero_to_one"]
            ],
            description: "Checks if first value (number) is lower than the second value (number)"
        },
        {
            operator_type: "(Number) \u003E=",
            operands_number: 2,
            operands_kinds: [
                ["integer", "float", "float_zero_to_one"],
                ["integer", "float", "float_zero_to_one"]
            ],
            description:
                "Checks if first value (number) is greater or equal than the second value (number)"
        },
        {
            operator_type: "(Number) \u003E",
            operands_number: 2,
            operands_kinds: [
                ["integer", "float", "float_zero_to_one"],
                ["integer", "float", "float_zero_to_one"]
            ],
            description: "Checks if first value (number) is greater than the second value (number)"
        },
        {
            operator_type: "(Number) !=",
            operands_number: 2,
            operands_kinds: [
                ["integer", "string", "float", "float_zero_to_one", "boolean", "list_of_values"],
                ["integer", "string", "float", "float_zero_to_one", "boolean", "list_of_values"]
            ],
            description: "Checks if two values given are not equal"
        },
        {
            operator_type: "!=",
            operands_number: 2,
            operands_kinds: [
                ["integer", "string", "float", "float_zero_to_one", "boolean", "list_of_values"],
                ["integer", "string", "float", "float_zero_to_one", "boolean", "list_of_values"]
            ],
            description: "Checks if two values given are not equal"
        },
        {
            operator_type: "(Number) ==",
            operands_number: 2,
            operands_kinds: [
                ["integer", "string", "float", "float_zero_to_one", "boolean", "list_of_values"],
                ["integer", "string", "float", "float_zero_to_one", "boolean", "list_of_values"]
            ],
            description: "Checks if two values given are equal"
        },
        {
            operator_type: "==",
            operands_number: 2,
            operands_kinds: [
                ["integer", "string", "float", "float_zero_to_one", "boolean", "list_of_values"],
                ["integer", "string", "float", "float_zero_to_one", "boolean", "list_of_values"]
            ],
            description: "Checks if two values given are equal"
        },
        {
            operator_type: "Exists",
            operands_number: 1,
            operands_kinds: [["*"]],
            description: "Checks if value is given (not `None`)"
        },
        {
            operator_type: "DoesNotExist",
            operands_number: 1,
            operands_kinds: [["*"]],
            description: "Checks if value is not given (`None`)"
        },
        {
            operator_type: "(Boolean) is True",
            operands_number: 1,
            operands_kinds: [["boolean"]],
            description: "Checks if value is `True`"
        },
        {
            operator_type: "(Boolean) is False",
            operands_number: 1,
            operands_kinds: [["boolean"]],
            description: "Checks if value is `False`"
        },
        {
            operator_type: "(Sequence) is empty",
            operands_number: 1,
            operands_kinds: [
                [
                    "list_of_values",
                    "dictionary",
                    "object_detection_prediction",
                    "instance_segmentation_prediction",
                    "keypoint_detection_prediction"
                ]
            ],
            description: "Checks if sequence is empty"
        },
        {
            operator_type: "(Sequence) is not empty",
            operands_number: 1,
            operands_kinds: [
                [
                    "list_of_values",
                    "dictionary",
                    "object_detection_prediction",
                    "instance_segmentation_prediction",
                    "keypoint_detection_prediction"
                ]
            ],
            description: "Checks if sequence is not empty"
        }
    ]
};

module.exports = { uqlDefinitions, uqlCondensedSchema };
